import React, { Component, createRef } from "react";
import commStyles from "../../common/styles";
import { connect } from "react-redux";
import { Container } from "../../common/components/Container";
import { Table } from "../../common/components/Table";
import { Model } from "../../common/components/Model";
import { ReactSelect } from "../../common/components/ReactSelect";
import apiCall from "../../common/utils/apiCall";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "../../common/styles/styles.css";

const {
  Form,
  FormColumn,
  FormRow,
  FormInput,
  FormInputLabel,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  SubHeading,
} = commStyles;

const columns = [
  { id: "title", label: "Blog Title", minWidth: "10%" },
  { id: "createdAt", label: "created on", minWidth: "10%" },
  { id: "updatedAt", label: "updated on", minWidth: "10%" },
  { id: "operationEditDelete", label: "Edit / Delete", minWidth: "10%" },
];
let mountLimit = 1;
let filterHeight = document.getElementById("filterDiv")
  ? `${document.getElementById("filterDiv").offsetHeight}px`
  : "10vh";

class Blogs extends Component {
  constructor(props) {
    super(props);
    this.quillRef = createRef();
    this.editModel = this.editModel.bind(this);
    this.state = {
      blogsData: [],
      totalSize: 0,
      rowsPerPage: 20,
      image: null,
      filterOptionsLimit: 20,
      deleteModelOpen: false,
      createModelOpen: false,
      editModelOpen: false,
      blogsFilterInput: "",
      blogsCreateInput: "",
      blogsFilterOptions: [],
      blogsCreateOptions: [],
      blogsFilterLoading: false,
      blogsCreateLoading: false,
      filterData: {},
      deleteData: {
      },
      createData: {},
      editData: {},
    };
  }

  async componentDidMount() {
    if (mountLimit == 1) {
      mountLimit++;
      try {
        const { result } = await apiCall("REACT_APP_GET_BLOG", "POST", {
          limit: this.state.rowsPerPage,
          skip: 0,
        });
        if (result && result["success"] && result["data"]) {
          let modifyData = await this.modifyApiData(result.data);
          this.setState({
            blogsData: modifyData,
            totalSize: await result.totalSize,
          });
          console.log( "Modify Data :::::::>>>>>>>",modifyData)
          toast.success(result.msg);
        }

      } catch (error) {
        console.log("blog componentDidMount Error ::", error);
      }
      setTimeout(() => {
        mountLimit--;
      }, 500);
    }
  }
  
  async modifyApiData(rawDataArray) {
    return await rawDataArray.map((data) => {
      data.createdAt = new Date(data.createdAt).toLocaleString();
      data.updatedAt = new Date(data.updatedAt).toLocaleString();
      data["operationDelete"] = data.id;

      return data;
    });
  }
  editModel(data) {
    let editData = this.state.editData;
    editData["id"] = data.id;
    editData["title"] = data.title;
    editData["description"] = data.description;
    editData["author"] = data.author;
    editData["content"] = data.content;
    editData["image"] = data.image;
    this.setState({ editData, editModelOpen: true });
  }
  deleteEntry = (data) => {
    let deleteData = this.state.deleteData;
    deleteData["id"] = data.id;
    this.setState({ deleteData, deleteModelOpen: true });
  };

  formatData = async (data, value, label) => {
    return await data.map((eachData) => {
      let obj = {};
      obj["value"] = eachData[value];
      obj["label"] = eachData[label];
      return obj;
    });
  };

  handleChange = async (event, state, stateEdit, stateCreate) => {
    if (!Array.isArray(event)) {
      event = [event];
    }
    if (stateEdit) {
      let editData = this.state.editData;
      await event.forEach((data) => (editData[stateEdit] = data.value));
      this.setState({ editData });
    } else if (stateCreate) {
      let createData = this.state.createData;
      createData[stateCreate] = "";
      await event.forEach((data) => (createData[stateCreate] = data.value));
      this.setState({ createData });
    } else {
      let filterData = this.state.filterData;
      filterData[state] = [];
      await event.forEach((data) => filterData[state].push(data.value));
      this.setState({ filterData });
      console.log("filterData", filterData);
    }
  };

  handleImageChange = (e) => {
    this.setState({ image: e.target.files[0] }); // Store the selected file
  };

  handleQuillChange = (content, fieldName, isEdit) => {
    if (isEdit) {
      const editData = { ...this.state.editData };
      editData[fieldName] = content;
      this.setState({ editData });
    } else {
      const createData = { ...this.state.createData };
      createData[fieldName] = content;
      this.setState({ createData });
    }
  };

  handleChangePage = async (chnagedPage, rowsPerPage) => {
    let filterData = this.state.filterData;
    let skippedEmptyArrayOfObj = [];
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = chnagedPage * rowsPerPage || 0;
    filterData["limit"] = rowsPerPage || 20;
    for (let i = 0; i < filterData["skip"]; i++) {
      skippedEmptyArrayOfObj.push({});
    }
    const { result } = await apiCall("REACT_APP_GET_BLOG", "POST", filterData);
    if (result && result["success"] && result["data"]) {
      let modifyData = await this.modifyApiData(result.data);
      this.setState({
        blogsData: [...skippedEmptyArrayOfObj, ...modifyData],
        rowsPerPage: rowsPerPage,
        totalSize: await result.totalSize,
      });
      return true;
    }
    return false;
  };

  handleBlogInputChange = async (blogsFilterInput, { action }) => {
    this.setState({ blogsFilterLoading: true });
    let input;
    let blogsFilterOptions = [];
    if (action === "set-value") {
      input = this.state.blogsFilterInput;
    } else {
      input = blogsFilterInput;
      this.setState({ blogsFilterInput });
    }
    if (input.split("").length >= 1) {
      const { result } = await apiCall("REACT_APP_GET_BLOG", "POST", {
        textToSearch: input,
        limit: this.state.filterOptionsLimit,
      });
      if (result && result.success) {
        blogsFilterOptions = await this.formatData(
          result.data,
          "id",
          "title"
        );
      }
    }

    this.setState({ blogsFilterOptions, blogsFilterLoading: false });
  };

  submitFilter = async (filterData) => {
    Object.keys(filterData).forEach((data) => {
      if (
        filterData[data] == [] ||
        filterData[data] == {} ||
        filterData[data] == ""
      ) {
        delete filterData[data];
      }
    });
    filterData["skip"] = 0;
    filterData["limit"] = this.state.rowsPerPage || 20;
    const { result } = await apiCall("REACT_APP_GET_BLOG", "POST", filterData);
    if (result && result["success"] && result["data"]) {
      let modifyData = await this.modifyApiData(result.data);
      this.setState({
        blogsData: modifyData,
        totalSize: await result.totalSize,
      });
      toast.success(result.msg);
    }
  };

  submitCreateForm = async (createData) => {
    Object.keys(createData).forEach((data) => {
      if (
        createData[data] == [] ||
        createData[data] == {} ||
        createData[data] == ""
      ) {
        delete createData[data];
      }
    });
    if (Object.keys(createData).length == 0) {
      return;
    }
    const {title, description, author, content} = createData;
    const {image} = this.state;
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("content", content);
    formData.append("author", author);
    if (image) {
      formData.append("image", image); // Append the file
    }
    const { result } = await apiCall(
      "REACT_APP_CREATE_BLOG",
      "POST",
      formData,
      true
    );
    if (result && result["success"] && result["data"]) {
      this.setState({ createModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };

  submitEditForm = async (editData) => {
    Object.keys(editData).forEach((data) => {
      if (
        editData[data] == [] ||
        editData[data] == {} ||
        editData[data] == ""
      ) {
        delete editData[data];
      }
    });
    if (Object.keys(editData).length == 0) {
      return;
    }
    const {id, title, description, author, content} = editData;
    const {image} = this.state;
    const formData = new FormData();
    formData.append("id", id);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("content", content);
    formData.append("author", author);
    if (image) {
      formData.append("image", image); // Append the file
    }
    const { result } = await apiCall("REACT_APP_UPDATE_BLOG", "POST", formData);
    if (result && result["success"] && result["data"]) {
      this.setState({ editModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };

  submitDeleteForm = async (deleteData) => {
    Object.keys(deleteData).forEach((data) => {
      if (
        deleteData[data] == [] ||
        deleteData[data] == {} ||
        deleteData[data] == ""
      ) {
        delete deleteData[data];
      }
    });
    if (Object.keys(deleteData).length == 0) {
      return;
    }
    const { result } = await apiCall(
      "REACT_APP_DELETE_BLOG",
      "POST",
      deleteData
    );
    if (result && result["success"] && result["data"]) {
      this.setState({ deleteModelOpen: false });
      this.submitFilter(this.state.filterData);
      toast.success(result.msg);
    }
  };

  render() {
    const modules = {
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ align: ["right", "center", "justify"] }],
          [{ list: "ordered" }, { list: "bullet" }],]
      }
    };
    
    console.log("[Blogs.jsx]::this.state::", typeof this.state, this.state);
    console.log("[Blogs.jsx]::this.props::", typeof this.props, this.state);
    return (
      <React.Fragment>
        <Container headerName="Blogs Manager" navPosition="7">
          <div
            id="filterDiv"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: filterHeight,
              border: "none",
              overflow: "none",
            }}
          >
            <div id="filterSelectDiv1">
              <ReactSelect
                label={"Blog Title"}
                placeholder={"Search Blogs"}
                inputValue={this.state.blogsFilterInput}
                onInputChange={this.handleBlogInputChange}
                options={this.state.blogsFilterOptions}
                stateFilterName={"id"}
                onChange={this.handleChange}
                isLoading={this.state.blogsFilterLoading}
                isMulti={true}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ButtonSuccess
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  height: "28px",
                  padding: "7px 10px",
                }}
                onClick={() => {
                  this.submitFilter(this.state.filterData);
                }}
              >
                <span id="filterButtonStyle">FILTER</span>
                <FilterAltIcon sx={{ width: "15px" }} />
              </ButtonSuccess>
              <ButtonSuccess
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "5px",
                  alignItems: "center",
                  height: "28px",
                  padding: "7px 10px",
                }}
                onClick={() => {
                  this.setState({ createModelOpen: true });
                }}
              >
                <span id="filterButtonStyle">CREATE</span>
                <AddCircleIcon sx={{ width: "15px" }} />
              </ButtonSuccess>
            </div>
          </div>
          <Table
            columns={columns || []}
            dataValues={this.state.blogsData || []}
            totalSize={this.state.totalSize || 0}
            filterHeight={filterHeight}
            rowsPerPage={this.state.rowsPerPage}
            handleChangePage={this.handleChangePage}
            editModel={this.editModel}
            deleteEntry={this.deleteEntry}
          />
        </Container>

        {/* DELETE MODEL */}
        <Model title={"Delete Blog"} modelOpen={this.state.deleteModelOpen}>
          <Form>
            <SubHeading>
              Are you sure, do you want to delete Blog data ?
            </SubHeading>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/blogs"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ deleteModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/blogs"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitDeleteForm(this.state.deleteData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* CREATE MODEL */}
        <Model
          title={"Create Blog"}
          modelOpen={this.state.createModelOpen}
          maxWidth={"1000px"}

        >
          <Form onSubmit={this.submitCreateForm}>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Blog Title</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  name="title"
                  value={this.state.createData.title}
                  placeholder="Blog Title"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "", "title");
                  }}
                />
              </FormColumn>
              <FormColumn>
                <FormInputLabel>Blog Description</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  name="description"
                  value={this.state.createData.description}
                  placeholder="Blog Description"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "", "description");
                  }}
                />
              </FormColumn>
              <FormColumn>
                <FormInputLabel>Author</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  name="author"
                  value={this.state.createData.author}
                  placeholder="Author"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "", "author");
                  }}
                />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Blog Content</FormInputLabel>
                <ReactQuill
                  ref={this.quillRef}
                  modules={modules}
                  value={this.state.createData.content}
                  onChange={(content, delta, source, editor) => {
                    // React Quill provides the HTML content directly, don't pass as event
                    this.handleQuillChange(content, "content", false);
                  }}
                  theme="snow"
                  placeholder="Write your blog content here..."
                />

              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Blog Image</FormInputLabel>
                <FormInput
                  type="file"
                  name="image"
                  onChange={this.handleImageChange}
                  required
                />
              </FormColumn>
            </FormRow>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/blogs"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ createModelOpen: false });
                  }}
                  style={{ textDecoration: "none" }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/blogs"}
              >
                <ButtonSuccess
                  style={{ marginLeft: "10px", textDecoration: "none" }}
                  onClick={() => {
                    this.submitCreateForm(this.state.createData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>

        {/* EDIT MODEL */}
        <Model title={"Edit Badge"} modelOpen={this.state.editModelOpen} maxWidth={"1000px"}>
          <Form>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Blog Title</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  value={this.state.editData ? this.state.editData.title : ""}
                  placeholder="blog Title"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "title");
                  }}
                ></FormInput>
              </FormColumn>
              <FormColumn>
                <FormInputLabel>Blog Description</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  name="description"
                  value={
                    this.state.editData.description
                      ? this.state.editData.description
                      : ""
                  }
                  placeholder="Blog Description"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "description");
                  }}
                />
              </FormColumn>
              <FormColumn>
                <FormInputLabel>Author</FormInputLabel>
                <FormInput
                  type="text"
                  required={true}
                  name="author"
                  value={
                    this.state.editData.author ? this.state.editData.author : ""
                  }
                  placeholder="Author"
                  onChange={(e) => {
                    this.handleChange(e.target, "", "author");
                  }}
                />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Blog Content</FormInputLabel>
                <ReactQuill
                  ref={this.quillRef}
                  modules={modules}
                  value={this.state.editData.content}
                  onChange={(content, delta, source, editor) => {
                    this.handleQuillChange(content, "content", true);
                  }}
                  theme="snow"
                  placeholder="Edit your blog content here..."
                />
              </FormColumn>
            </FormRow>
            <FormRow>
              <FormColumn>
                <FormInputLabel>Blog Image</FormInputLabel>
                <FormInput
                  type="file"
                  name="image"
                  onChange={this.handleImageChange}
                  required
                />
              </FormColumn>
            </FormRow>
            <ButtonWrapper>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/blogs"}
              >
                <ButtonSecondary
                  onClick={() => {
                    this.setState({ editModelOpen: false });
                  }}
                >
                  Cancel
                </ButtonSecondary>
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                }}
                to={"/admin/blogs"}
              >
                <ButtonSuccess
                  style={{
                    marginLeft: "10px",
                    textDecoration: "none",
                  }}
                  onClick={() => {
                    this.submitEditForm(this.state.editData);
                  }}
                >
                  Submit
                </ButtonSuccess>
              </Link>
            </ButtonWrapper>
          </Form>
        </Model>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Blogs);
